import GoodsInCreate from "./GoodsInCreate";

export default GoodsInCreate;
